import { http } from '@/lib/api-client'
import type {
  AddBranchMemberInput,
  AddBranchMemberResult,
  Branch,
  CreateBranchInput,
} from './branch.types'

// Branch membership — /api/branch. Scoped to the caller's active branch.
export const branchApi = {
  // Create a new branch. The caller is auto-enrolled as its admin. Listing +
  // switching branches is handled by authClient.organization (Better Auth).
  create: (data: CreateBranchInput): Promise<Branch> =>
    http.post<{ data: Branch }>('/branch', data).then((r) => r.data),

  // Rename a branch (display name only).
  update: (id: string, data: { name: string }): Promise<Branch> =>
    http.patch<{ data: Branch }>(`/branch/${id}`, data).then((r) => r.data),

  // Permanently delete a branch AND all of its data. Irreversible.
  remove: (id: string): Promise<void> => http.delete(`/branch/${id}`),

  // The active branch's default WhatsApp session id (null if none).
  getDefaultWhatsapp: (): Promise<string | null> =>
    http
      .get<{ data: { sessionId: string | null } }>('/branch/whatsapp-default')
      .then((r) => r.data.sessionId),

  // Set (or clear, with null) the active branch's default WhatsApp session.
  setDefaultWhatsapp: (sessionId: string | null): Promise<string | null> =>
    http
      .patch<{ data: { sessionId: string | null } }>('/branch/whatsapp-default', {
        sessionId,
      })
      .then((r) => r.data.sessionId),

  // Add-or-create a staff member in the active branch. Branch admins only.
  addMember: (data: AddBranchMemberInput): Promise<AddBranchMemberResult> =>
    http
      .post<{ data: AddBranchMemberResult }>('/branch/members', data)
      .then((r) => r.data),
}
